/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeExportJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Export Job Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 16, 2019 - 01:51:12 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      12/16/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const EXPORTJOB_LIST_CONTAINER_LOADED = 'EXPORTJOB_LIST_CONTAINER_LOADED';
export const EXPORTJOB_LIST_CONTAINER_UNLOADED = 'EXPORTJOB_LIST_CONTAINER_UNLOADED';
export const EXPORTJOB_LIST_TABLE_LOADED = 'EXPORTJOB_LIST_TABLE_LOADED';
export const EXPORTJOB_LIST_TABLE_UNLOADED = 'EXPORTJOB_LIST_TABLE_UNLOADED';

export const EXPORTJOB_LIST_CHANGE_GROUP = 'EXPORTJOB_LIST_CHANGE_GROUP';
export const EXPORTJOB_SELECT_ROW = 'EXPORTJOB_SELECT_ROW';
export const EXPORTJOB_UPDATE_VALUE = 'EXPORTJOB_UPDATE_VALUE';

export const EXPORTJOB_ADD = 'EXPORTJOB_ADD';
export const EXPORTJOB_EDIT = 'EXPORTJOB_EDIT';
export const EXPORTJOB_DELETE = 'EXPORTJOB_DELETE';
export const EXPORTJOB_OPEN_WARNING = 'EXPORTJOB_OPEN_WARNING';
export const EXPORTJOB_CLOSE_WARNING = 'EXPORTJOB_CLOSE_WARNING';
export const EXPORTJOB_DELETE_DISABLE = 'EXPORTJOB_DELETE_DISABLE';
export const EXPORTJOB_VIEW_CHILD_ITEMS = 'EXPORTJOB_VIEW_CHILD_ITEMS';

export const EXPORTJOB_EDIT_CONTAINER_LOADED = 'EXPORTJOB_EDIT_CONTAINER_LOADED';
export const EXPORTJOB_EDIT_CONTAINER_UNLOADED = 'EXPORTJOB_EDIT_CONTAINER_UNLOADED';
export const EXPORTJOB_EDIT_FORM_LOADED = 'EXPORTJOB_EDIT_FORM_LOADED';
export const EXPORTJOB_EDIT_FORM_UNLOADED = 'EXPORTJOB_EDIT_FORM_UNLOADED';

export const EXPORTJOB_SET_GROUP_SELECT = 'EXPORTJOB_SET_GROUP_SELECT';
export const EXPORTJOB_EDIT_DATA_LOAD = 'EXPORTJOB_EDIT_DATA_LOAD';

export const EXPORTJOB_EDIT_CONTAINER_SUBMIT = 'EXPORTJOB_EDIT_CONTAINER_SUBMIT';
export const EXPORTJOB_EDIT_CONTAINER_CANCEL = 'EXPORTJOB_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeExportJobs.js